import React, { FC } from 'react'
import { LocationWithContactDto } from '@apiModels/LocationWithContactDto.csharp';

import { InfoWithBanner } from '../InfoWithBanner';
import { LocationsContactInfo } from '../LocationsContactInfo';

interface ContactInfoProps {
  header: string;
  locations: LocationWithContactDto[];
}

export const ContactInfo: FC<ContactInfoProps> = (props) => {
  const { header, locations } = props;
  return (
    <div className='contactInfo'>
      <InfoWithBanner
        header={
          <h1 className="contactInfo__header">{header}</h1>
        }
        body={
          <div className="contactInfo__info">
            <LocationsContactInfo<LocationWithContactDto>
              locations={locations}
            />
          </div>
        }
      />
    </div>
  )
};

